import React from "react";
import { Edit, SimpleForm, TextInput, required } from "react-admin";
import { Typography } from "@material-ui/core";

export function CountryEdit(props: any): JSX.Element {
  return (
    <Edit {...props} mutationMode="pessimistic">
      <SimpleForm>
        <Typography variant="h6">Edit Country</Typography>
        <TextInput source="name" validate={[required()]} fullWidth />
        <TextInput
          source="isoCode"
          label="Country Code"
          validate={[required()]}
          helperText="ISO 3166-1 alpha-2 two-letter country code (e.g. 'US', 'GB', 'DE')"
          fullWidth
        />
      </SimpleForm>
    </Edit>
  );
}
